import { memo, Suspense } from 'react';
import { ColorManagement } from 'three';
import { tunnels } from 'modules/editor/tunnels';
import { EditorSetup } from 'modules/editor/components/EditorSetup';
import { Overlays } from 'modules/editor/components/Overlays';
import { Canvas } from 'modules/editor/components/Canvas';
import { Loader } from 'modules/editor/components/Loader';
import { dispatcher } from 'modules/editor/events';
import VisibleWithMouse from 'components/VisibleWithMouse';
import { Coverage } from 'modules/editor/containers/coverage/Coverage';
import { PointerCoordinates } from 'modules/editor/components/PointerCoordinates';
import { Devices } from './Devices';
import { ContextMenu } from './ContextMenu';

// https://docs.pmnd.rs/react-three-fiber/advanced/scaling-performance#re-using-geometries-and-materials
ColorManagement.enabled = true;
const onPointerMissed = () => dispatcher.pointerMissed();

function EditorImpl() {
  return (
    <>
      <Overlays />

      <Canvas onPointerMissed={onPointerMissed}>
        <Suspense fallback={<Loader />}>
          <EditorSetup />
          <Coverage />
          <Devices />
          <ContextMenu />
          <VisibleWithMouse>
            <PointerCoordinates />
          </VisibleWithMouse>
        </Suspense>
      </Canvas>

      <tunnels.editor.Out />
    </>
  );
}

export const Editor = memo(EditorImpl);
